import {
    FETCH_EVT,
    FETCH_EVTS,
    STORE_EVTS_COLUMNS,
    REPLACE_EVT_IN_EVTS,
} from '../actions/evt';




export const initialState = {
    isFetching: true,
    data: null
};

export const evts = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EVTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EVTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        case STORE_EVTS_COLUMNS:
            return Object.assign({}, state, {
                extra: {
                    columns: action.columns
                }
            });
        case REPLACE_EVT_IN_EVTS:
            if (!state.data || !Array.isArray(state.data) || !action.evt || !action.evt.data) {
                return Object.assign({}, state, {});
            }
            const replactedData = state.data.map((evt, index) => {
                return evt.header.id == action.evtId ? action.evt.data : evt;
            })

            return Object.assign({}, state, {data: replactedData});

        default:
            return state;
    }
}




export const evt = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EVT}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EVT}_SUCCESS`:
            const evt = action.payload.data;
            return Object.assign({}, state, {
                isFetching: false,
                data: evt,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/evt.js